<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Editar | Estudiante | {{nombre_participante}}</h3>
      </div>
    </div>
  </div>




  <form [formGroup]="formularioRegistro" id="formularioReprogrma">

    <!------ datos_personales ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Información Personal</h5>
        </div>
        <div class="row g-3">
          <!--Fila 1-->
          <div class="row mt-4">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  País de origen <span style="color: red;">*</span>
                </label>
                <select class="form-select" id="id_pais" formControlName="id_pais">
                  <option value="" [selected]="true">--Seleccione--</option>
                  <option *ngFor="let a of arrPais;" value="{{a.id_pais}}">{{a.pais_nombre}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Identificacion:</label>
                <div class="row" style="--bs-gutter-x: 0px;">
                  <div class="col-2">
                    <input type='text' id='nro_doc' formControlName="nro_doc" class='form-control' [readOnly]="true">
                  </div>
                  <div class="col-10">
                    <input type="text" id="documento" formControlName="documento" class="form-control" [readOnly]="true">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Fila 2-->
          <div class="row mt-4">
            <div class='col-md-6'>
              <div class='mb-3'>
                <label class='form-label'>Nombre(s) <span style="color: red;">*</span></label>
                <input type='text' id='nombre' formControlName="nombre" class='form-control'>
              </div>
            </div>
            <div class='col-md-6'>
              <div class='mb-3'>
                <label class='form-label'>Apellido(s) <span style="color: red;">*</span></label>
                <input type='text' id='apellido' formControlName="apellido" class='form-control'>
              </div>
            </div>
          </div>
          <!--Fila 3-->
          <div class="row mt-4">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Género <span style="color: red;">*</span>
                </label>
                <select class="form-select" id="genero" formControlName="genero">
                  <option value="1">Masculino</option>
                  <option value="2">Femenino</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Fecha de nacimiento <span class="text-danger">*</span></label>
              <div class="input-group">
                <input class="form-control" placeholder="Fecha de nacimiento" (dateSelect)="calcula_edad()" formControlName="fch_nacimiento" [readOnly]="true" #fch="ngbDatepicker" ngbDatepicker>
                <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fch.toggle()" type="button"></button>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Edad <span class="text-danger">*</span></label>
              <input type="text" class="form-control" name="edad" formControlName="edad" placeholder="Edad" mask="99" readonly>
            </div>
            <div class='col-md-3'>
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Estado civil <span style="color: red;">*</span>
                </label>
                <select class="form-select" id='edo_civil' formControlName="edo_civil">
                  <option value="1">Soltero</option>
                  <option value="2">Casado</option>
                  <!--option value="3">Divorciado</option-->
                  <!--option value="4">Viudo</option-->
                  <option value="5">En unión</option>
                  <option value="6">Otro</option>
                </select>
              </div>
            </div>
          </div>
          <!--Fila 4-->
          <div class="row mt-4">
            <div class="col-12">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Lugar de nacimiento <span style="color: red;">*</span>
                </label>
                <input type='text' id='lugar_nacimiento' formControlName="lugar_nacimiento" class='form-control'>
              </div>
            </div>
          </div>
          <!--Fila 5-->
          <div class="row mt-4">
            <div class="col-md-2 mb-3 text-center">
              <label class='form-label'>¿Tiene hijos?</label>
              <div class="form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="tiene_hijos" formControlName="tiene_hijos" (click)="hijos($event)" style="font-size: 25px;">
              </div>
            </div>
            <div class='col-md-2' [style.display]=" tieneHijo ? 'block' : 'none'">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Indique
                </label>
                <select class="form-select" id='indique_hijos' formControlName="indique_hijos" (change)="verifica_hijo($event)">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">Otros</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" [style.display]=" valida_hijos ? 'block' : 'none'">
              <div class='mb-3'>
                <label class='form-label'>Indique otros</label>
                <input type='text' id='otros_hijos' formControlName="otros_hijos" class='form-control' mask="99">
              </div>
            </div>
            <div class="col-md-3 mb-3 text-center">
              <label for='simpleinput' class='form-label'>¿Pertenece algún grupo étnico? <span style="color: red;">*</span></label>
              <div class="form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="grupo_etnico" formControlName="grupo_etnico" (click)="validaGrupoEtnico($event)" style="font-size: 25px;">
              </div>
            </div>
            <div class='col-md-3' [style.display]=" cmbGrupoEtnico ? 'block' : 'none'">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Indique
                </label>
                <select class="form-select" id='indique_etnia' formControlName="indique_etnia">
                  <option value="" [selected]="true">--Seleccione--</option>
                  <option *ngFor="let a of arrGrupoEtnico;" value="{{a.id_grupo_etnico}}">{{a.nombre}}</option>
                </select>
              </div>
            </div>
          </div>
          <!--Fila 6-->
          <div class="row mt-4">
            <div class='col-md-3 mb-3 text-center'>
              <label for='simpleinput' class='form-label'>¿Posee alguna discapacidad? <span style="color: red;">*</span></label>
              <div class="form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="discapacidad" formControlName="discapacidad" (click)="validaDiscapacidad($event)" style="font-size: 25px;">
              </div>
            </div>
            <div class='col-md-3' [style.display]=" cmbDiscapacidad ? 'block' : 'none'">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Indique
                </label>
                <select class="form-select" id='indique_discapacidad' formControlName="indique_discapacidad" >
                  <option value="" [selected]="true">--Seleccione--</option>
                  <option *ngFor="let a of arrDiscapacidad;" value="{{a.id_discapacidad}}">{{a.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-3 mb-3 text-center" [style.display]=" cmbDiscapacidad ? 'block' : 'none'">
              <label class='form-label'>¿Tiene certificado de discapacidad?</label>
              <div class="form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="certificado_discapacidad" formControlName="certificado_discapacidad" (click)="certificadoDiscapacidad($event)" style="font-size: 25px;">
              </div>
            </div>
            <div class='col-md-3' [style.display]=" cmbDiscapacidad && tieneCertificado ? 'block' : 'none'">
              <div class="mb-3">
                <div class="form-group">
                  <label for="example-select" class="form-label">
                    Número de carnet CONAPDIS
                  </label>
                  <div class="input-group">
                    <div class="input-group-append" id="ver_pass">
                      <select class="form-select input-group-text" id="tp_dis" formControlName="tp_dis" style="padding: 0.45rem 2rem;">
                        <option value="A">A</option>
                        <option value="B">C</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>
                        <option value="F">F</option>
                        <option value="G">G</option>
                        <option value="H">H</option>
                        <option value="I">I</option>
                        <option value="J">J</option>
                        <option value="K">K</option>
                        <option value="L">L</option>
                        <option value="M">M</option>
                        <option value="N">N</option>
                        <option value="Ñ">Ñ</option>
                        <option value="O">O</option>
                        <option value="P">P</option>
                        <option value="Q">Q</option>
                        <option value="R">R</option>
                        <option value="S">S</option>
                        <option value="T">T</option>
                        <option value="U">U</option>
                        <option value="V">V</option>
                        <option value="W">W</option>
                        <option value="X">X</option>
                        <option value="Y">Y</option>
                        <option value="Z">Z</option>
                      </select>
                    </div>
                    <input type='text'
                      id='numero_discapacidad'
                      formControlName="numero_discapacidad"
                      class='form-control'
                      mask="9999999999">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------ datos_constacto ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Datos Contactos</h5>
        </div>
        <div class="row g-3">
          <!--Fila 1-->
          <div class="row mt-4">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  País de residencia <span style="color: red;">*</span>
                </label>
                <!-- Multiple Select -->
                <select class="form-select" id="pais_residencia" formControlName="pais_residencia">
                  <option value="{{id_pais_re}}" selected>Venezuela</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Estado <span style="color: red;">*</span>
                </label>
                <!-- Multiple Select -->
                <select class="form-control" id='estado' formControlName="estado" (change)="municipio()">
                  <option value="" [selected]="true">--seleccione--</option>
                  <option *ngFor="let a of arrEstado;" value="{{a.id_estado}}">{{a.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Municipio <span style="color: red;">*</span>
                </label>
                <!-- Multiple Select -->
                <select class="form-control" id='municipio' formControlName="municipio" (change)="parroquia()">
                  <option value="" [selected]="true">--seleccione--</option>
                  <option *ngFor="let a of arrMunicipio;" value="{{a.id}}">{{a.nombre}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Parroquia <span style="color: red;">*</span>
                </label>
                <!-- Multiple Select -->
                <select class="form-control" id='parroquia' formControlName="parroquia">
                  <option value="" [selected]="true">--seleccione--</option>
                  <option *ngFor="let a of arrParroquia;" value="{{a.id}}">{{a.nombre}}</option>
                </select>
              </div>
            </div>
          </div>
          <!--Fila 2-->
          <div class="row mt-4">
            <div class="col-md-3">
              <div class='mb-3'>
                <label for='simpleinput' class='form-label'>Ciudad <span style="color: red;">*</span></label>
                <input type='text' id='ciudad' formControlName="ciudad" class='form-control'>
              </div>
            </div>
            <div class="col-md-3">
              <div class='mb-3'>
                <label for='simpleinput' class='form-label'>Sector o punto de referencia <span style="color: red;">*</span></label>
                <input type='text' id='sector' formControlName="sector"  class='form-control'>
              </div>
            </div>
            <div class="col-md-6">
              <div class='mb-3'>
                <label for='simpleinput' class='form-label'>Dirección de residencia <span style="color: red;">*</span></label>
                <input type='text' id='direccion_residencia' formControlName="direccion_residencia" class='form-control'>
              </div>
            </div>
          </div>
          <!--Fila 3-->
          <div class="row mt-4">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Teléfono local</label>
                <div class="input-group">
                    <select class="form-select" id='tipo_operadora' formControlName="tipo_operadora" >
                      <option value="" [selected]="true">--Seleccione--</option>
                      <option *ngFor="let a of arrOperadora;" value="{{a.operadora}}">{{a.operadora}}</option>
                    </select>
                    <input type="text" id='tlf_local' formControlName="tlf_local" class="form-control" mask="99999999">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Teléfono móvil <span style="color: red;">*</span></label>
                <div class="input-group">
                    <select class="form-select" id='tipo_operadora_movil' formControlName="tipo_operadora_movil">
                      <option value="" [selected]="true">--Seleccione--</option>
                      <option *ngFor="let a of arrOperadoraMovil;" value="{{a.operadora}}">{{a.operadora}}</option>
                    </select>
                    <input type="text" id='tlf_local_movil' formControlName="tlf_local_movil" class="form-control" mask="99999999">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class='mb-3'>
                <label class='form-label'>Correo electrónico (Preferiblemente Gmail) <span style="color: red;">*</span></label>
                <input type='text' id='correo' formControlName="correo" class='form-control'>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------ datos_academicos ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Datos Académicos</h5>
        </div>
        <div class="row g-3">
          <!--Fila 1-->
          <div class="row mt-4">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Grado de instrucción <span style="color: red;">*</span>
                </label>
                <select class="form-select" id='grado_instruccion' formControlName="grado_instruccion" >
                  <option value="1">Primaria Incompleta</option>
                  <option value="2">Primaria Completa</option>
                  <option value="3">Bachillerato Incompleto</option>
                  <option value="4">Bachillerato Completo</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Último año aprobado <span style="color: red;">*</span>
                </label>
                <select class="form-select" id='ultimo_ano' formControlName="ultimo_ano">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
              </div>
            </div>
          </div>
          <!--Fila 2-->
          <div class="row mt-4">
            <div class='col-md-6'>
              <div class="mb-3">
                <div class="form-group">
                  <label for="example-select" class="form-label">
                    Contraseña del usuario<span style="color: red;">*</span>
                  </label>
                  <div class="input-group">
                    <input type='password' id='password' formControlName="password" class='form-control'>
                    <div class="input-group-append" style="cursor: pointer;" id="ver_pass" (click)="ver_pass(1)">
                        <span class="input-group-text">
                          ver
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-md-6'>
              <div class="mb-3">
                <label for="example-select" class="form-label">
                  Repita contraseña del usuario <span style="color: red;">*</span>
                </label>
                <div class="input-group">
                  <input type='password' id='re_password' formControlName="re_password"  class='form-control'>
                  <div class="input-group-append" style="cursor: pointer;" (click)="ver_pass(2)">
                      <span class="input-group-text">
                        ver
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------ Expedientes ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Expediente Digital</h5>
        </div>
      </div>
      <div class="row g-3 container-fluid">
        <ol>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Notas certificadas del último año de estudio aprobado.&nbsp;&nbsp;
                <label for="fliNotas" class="label-file btn btn-sm btn-primary">{{txtNotas}}</label>
                <input id="fliNotas" style="display:none;" type="file" (change)="cambia(1, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valNotas">
                <embed id="imgNotas" [src]="valNotas" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Comprobante de aprobación de 6to grado.&nbsp;&nbsp;
                <label for="fliConstancia" class="label-file btn btn-sm btn-primary">{{txtConstancia}}</label>
                <input id="fliConstancia" style="display:none;" type="file" (change)="cambia(2, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valConstancia">
                <embed id="imgConstancia" [src]="valConstancia" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Fotografía tipo carnet (26x32 mm).&nbsp;&nbsp;
                <label for="fliFotografia" class="label-file btn btn-sm btn-primary">{{txtFotografia}}</label>
                <input id="fliFotografia" style="display:none;" type="file" (change)="cambia(3, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valFotografia">
                <embed id="imgFotografia" [src]="valFotografia" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Acta de nacimiento.&nbsp;&nbsp;
                <label for="fliCarnet" class="label-file btn btn-sm btn-primary">{{txtCarnet}}</label>
                <input id="fliCarnet" style="display:none;" type="file" (change)="cambia(4, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valCarnet">
                <embed id="imgCarnet" [src]="valCarnet" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Documento de identidad.&nbsp;&nbsp;
                <label for="fliCedula" class="label-file btn btn-sm btn-primary">{{txtCedula}}</label>
                <input id="fliCedula" style="display:none;" type="file" (change)="cambia(5, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valCedula">
                <embed id="imgCedula" [src]="valCedula" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Notas certificadas del último año de estudio aprobado.&nbsp;&nbsp;
                <label for="fliRepresentante" class="label-file btn btn-sm btn-primary">{{txtRepresentante}}</label>
                <input id="fliRepresentante" style="display:none;" type="file" (change)="cambia(6, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valRepresentante">
                <embed id="imgRepresentante" [src]="valRepresentante" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Comprobante de aprobación de 6to grado.&nbsp;&nbsp;
                <label for="fliSalud" class="label-file btn btn-sm btn-primary">{{txtSalud}}</label>
                <input id="fliSalud" style="display:none;" type="file" (change)="cambia(7, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valSalud">
                <embed id="imgSalud" [src]="valSalud" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Fotografía tipo carnet (26x32 mm).&nbsp;&nbsp;
                <label for="fliRif" class="label-file btn btn-sm btn-primary">{{txtRif}}</label>
                <input id="fliRif" style="display:none;" type="file" (change)="cambia(8, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valRif">
                <embed id="imgRif" [src]="valRif" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Acta de nacimiento.&nbsp;&nbsp;
                <label for="fliCurriculum" class="label-file btn btn-sm btn-primary">{{txtCurriculum}}</label>
                <input id="fliCurriculum" style="display:none;" type="file" (change)="cambia(9, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valCurriculum">
                <embed id="imgCurriculum" [src]="valCurriculum" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Documento de identidad.&nbsp;&nbsp;
                <label for="fliReferencia" class="label-file btn btn-sm btn-primary">{{txtReferencia}}</label>
                <input id="fliReferencia" style="display:none;" type="file" (change)="cambia(10, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valReferencia">
                <embed id="imgReferencia" [src]="valReferencia" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
          <li class="mb-2">
            <div class="row">
              <div class="col-md-6 mt-3">
                Documento de identidad.&nbsp;&nbsp;
                <label for="fliLopna" class="label-file btn btn-sm btn-primary">{{txtLopna}}</label>
                <input id="fliLopna" style="display:none;" type="file" (change)="cambia(11, $event)" accept=".pdf">
              </div>
              <div class="col-6" *ngIf="valLopna">
                <embed id="imgLopna" [src]="valLopna" type="application/pdf" width="55%" height="200px"/>
              </div>
            </div>
          </li>
        </ol>
      </div>




    </div>

    <!------ Editar Estudiante ------>
    <hr class="text-dark">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-lg btn-primary" (click)="guardar_todo()">Editar</button>
    </div>

  </form>








</div>


<div style="margin-bottom: 300px;"></div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
